import * as React from "react"

// styles
const pageStyles = {
  color: "#232129",
  padding: "96px",
  fontFamily: "-apple-system, Roboto, sans-serif, serif",
}

// markup
const NotFoundPage: React.FunctionComponent<any> = () => {
  return (
    <main style={pageStyles}>
      {/*Parece que essa página não existe*/}
    </main>
  )
}

export default NotFoundPage
